import { axiosInstance } from '../config/axiosConfig';
import { API_ENDPOINTS } from '../endpoints/endpoints';

export interface Notification {
  id: string;
  type: 'message' | 'listing' | 'system' | 'other' | 'new_conversation';
  title: string;
  message: string;
  read: boolean;
  data?: {
    conversationId?: string;
    listingId?: string;
    conversation?: any; // Full conversation object for new_conversation type
    [key: string]: any;
  };
  createdAt: string;
}

export interface NotificationCount {
  unread: number;
  total: number;
}

export const notificationService = {
  // Get all notifications
  getNotifications: async (
    page = 1,
    limit = 20
  ): Promise<{
    notifications: Notification[];
    pagination: {
      page: number;
      limit: number;
      total: number;
      totalPages: number;
    };
  }> => {
    const { data } = await axiosInstance.get<{
      success: boolean;
      data: {
        notifications: Notification[];
        pagination: {
          page: number;
          limit: number;
          total: number;
          totalPages: number;
        };
      };
    }>(API_ENDPOINTS.NOTIFICATIONS.GET_ALL, {
      params: { page, limit },
    });
    return data.data;
  },

  // Get unread notification count
  getUnreadCount: async (): Promise<number> => {
    const { data } = await axiosInstance.get<{
      success: boolean;
      data: { count: number };
    }>(API_ENDPOINTS.NOTIFICATIONS.UNREAD_COUNT);
    return data.data.count;
  },

  // Mark notification as read
  markAsRead: async (notificationId: string): Promise<void> => {
    await axiosInstance.patch(
      API_ENDPOINTS.NOTIFICATIONS.MARK_AS_READ(notificationId)
    );
  },

  // Mark all notifications as read
  markAllAsRead: async (): Promise<void> => {
    await axiosInstance.patch(API_ENDPOINTS.NOTIFICATIONS.MARK_ALL_AS_READ);
  },

  // Delete a notification
  deleteNotification: async (notificationId: string): Promise<void> => {
    await axiosInstance.delete(
      API_ENDPOINTS.NOTIFICATIONS.DELETE(notificationId)
    );
  },
};
